"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradingBotResConvertUtils = void 0;
/**
 * @author Zhoukai
 * @date 2023/12/14
 * @time 14:20
 * @fileName TradingBotResConvertUtils.ts
 * @Description: BaseBotApiAdapter 内部分接口返回值转换函数导出供跟单库使用
 */
const decimal_js_1 = require("decimal.js");
const trade_utils_lib_1 = require("trade_utils_lib");
const ExchangeID_1 = require("../ExchangeAPI/ExchangeID");
const TradeTypeDef_1 = require("../ExchangeAPIAdapter/TradeTypeDef");
const TradeUtils_1 = require("./TradeUtils");
exports.TradingBotResConvertUtils = {
    /**
     * @description: 网格类订单交易记录转换为配对的记录。
     * @param value
     * @param supportTradingBotApiHost  支持使用last_trade_timestamp的订单类型，
     * @param queryOrderType 查询的订单类型
     */
    queryGridPairedCloseOrderListV2Handle(value, supportTradingBotApiHost, queryOrderType) {
        const result = value;
        const orderList = result.results.map((item) => {
            let baseDisplay = "";
            let isLeverage = false;
            // isLeverage: findSymbol ? findSymbol.isLeverage : false,
            if ("sell" in item && item.sell) {
                const symbolInfo = TradeUtils_1.TradeUtils.parseDisplay(item.sell.base, item.sell.quote, ExchangeID_1.ExchangeID.PIONEXV2);
                baseDisplay = symbolInfo ? symbolInfo.baseDisplay : item.sell.base;
                isLeverage = symbolInfo ? symbolInfo.isLeverage : false;
            }
            if ("buy" in item && item.buy) {
                const symbolInfo = TradeUtils_1.TradeUtils.parseDisplay(item.buy.base, item.buy.quote, ExchangeID_1.ExchangeID.PIONEXV2);
                baseDisplay = symbolInfo ? symbolInfo.baseDisplay : item.buy.base;
                isLeverage = symbolInfo ? symbolInfo.isLeverage : false;
            }
            let result = {
                sellOrder: "sell" in item && item.sell
                    ? {
                        id: item.sell.exchange_order_id,
                        orderType: item.sell.type,
                        base: item.sell.base,
                        quote: item.sell.quote,
                        baseDisplay: baseDisplay,
                        isLeverage: isLeverage,
                        symbol: item.sell.symbol,
                        timestamp: item.sell.timestamp,
                        lastTradeTime: supportTradingBotApiHost.includes(queryOrderType)
                            ? item.sell.last_trade_timestamp
                            : item.sell.lastTradeTimestamp,
                        tag: item.sell.tag,
                        state: "submitted",
                        isRunning: TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(item.sell.status, (item.sell.filled ? item.sell.filled : 0) > 0)),
                        originOrderData: item,
                        exchangeCustomOrder: {
                            side: item.sell.side,
                            type: item.sell.type,
                            price: item.sell.price,
                            amount: item.sell.amount,
                            average: item.sell.average,
                            filled_amount: item.sell.filled ? item.sell.filled : 0,
                            filled_value: item.sell.cost ? item.sell.cost : 0,
                            avgDealPrice: item.sell.cost ? new decimal_js_1.Decimal(item.sell.cost).div(item.sell.filled).toNumber() : 0,
                            feeInQuote: item.sell.fee_in_quote ? Number(item.sell.fee_in_quote) : 0,
                            fee: item.sell.fee,
                            feeCoin: item.sell.fee_coin ? item.sell.fee_coin.toUpperCase() : "",
                            feeRefund: item.sell.fee_income_cost,
                            feeRefundCoin: item.sell.fee_income_coin ? item.sell.fee_income_coin.toUpperCase() : "",
                            source: "",
                        },
                    }
                    : undefined,
                buyOrder: "buy" in item && item.buy
                    ? {
                        id: item.buy.exchange_order_id,
                        orderType: item.buy.type,
                        base: item.buy.base,
                        quote: item.buy.quote,
                        baseDisplay: baseDisplay,
                        isLeverage: isLeverage,
                        symbol: item.buy.symbol,
                        timestamp: item.buy.timestamp,
                        lastTradeTime: supportTradingBotApiHost.includes(queryOrderType)
                            ? item.buy.last_trade_timestamp
                            : item.buy.lastTradeTimestamp,
                        tag: item.buy.tag,
                        state: "submitted",
                        isRunning: TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(item.buy.status, (item.buy.filled ? item.buy.filled : 0) > 0)),
                        originOrderData: item,
                        exchangeCustomOrder: {
                            tag: item.buy.tag,
                            side: item.buy.side,
                            type: item.buy.type,
                            price: item.buy.price,
                            amount: item.buy.amount,
                            average: item.buy.average,
                            filled_amount: item.buy.filled ? item.buy.filled : 0,
                            filled_value: item.buy.cost ? item.buy.cost : 0,
                            avgDealPrice: item.buy.cost ? new decimal_js_1.Decimal(item.buy.cost).div(item.buy.filled).toNumber() : 0,
                            fee: item.buy.fee,
                            feeInQuote: item.buy.fee_in_quote ? Number(item.buy.fee_in_quote) : 0,
                            feeCoin: item.buy.fee_coin ? item.buy.fee_coin.toUpperCase() : "",
                            feeRefund: item.buy.fee_income_cost,
                            feeRefundCoin: item.buy.fee_income_coin ? item.buy.fee_income_coin.toUpperCase() : 0,
                            source: "",
                        },
                    }
                    : undefined,
            };
            return {
                tag: result.buyOrder ? result.buyOrder.tag : result.sellOrder.tag,
                sellOrder: result.sellOrder,
                buyOrder: result.buyOrder,
            };
        });
        return {
            nextPageToken: "next_page_token" in result ? result["next_page_token"] : undefined,
            pairedOrderList: orderList,
        };
    },
    queryGridProBalanceSequenceHandle(resp, queryOrderType) {
        let dataList = [];
        if (Array.isArray(resp.results)) {
            dataList = resp.results;
        }
        if (Array.isArray(resp)) {
            dataList = resp;
        }
        const list = dataList.map((obj) => {
            const useTotalProfit = [
                TradeTypeDef_1.ExchangeOrderType.gridV4,
                TradeTypeDef_1.ExchangeOrderType.gridV5,
                TradeTypeDef_1.ExchangeOrderType.gridV4Futures,
                TradeTypeDef_1.ExchangeOrderType.gridV4FuturesHedgeGrid,
            ].includes(queryOrderType);
            const profit = new trade_utils_lib_1.SafeDecimal(useTotalProfit ? obj.total_profit : obj.profit).toString();
            const investment = obj.investment || obj.quote_investment || "0";
            return {
                time_block: Number(trade_utils_lib_1.NumberCommonUtils.formatterDecimal(obj.timestamp / 1000, 0)),
                profit: profit,
                gridProfit: new trade_utils_lib_1.SafeDecimal(obj.profit).toString(),
                balance: new trade_utils_lib_1.SafeDecimal(obj.balance).toString(),
                transactions: obj.transaction.toString(),
                investment: investment,
                quote_price: new trade_utils_lib_1.SafeDecimal(obj.quote_price).toString(),
                price: new trade_utils_lib_1.SafeDecimal(obj.price).toString(),
                extra_margin: new trade_utils_lib_1.SafeDecimal(obj.extra_margin).toString(),
                balance_in_usdt: obj.balance_in_usdt ? new trade_utils_lib_1.SafeDecimal(obj.balance_in_usdt).toString() : null,
                total_profit_in_usdt: obj.total_profit_in_usdt ? new trade_utils_lib_1.SafeDecimal(obj.total_profit_in_usdt).toString() : null,
                base_amount: obj.base_amount ? new trade_utils_lib_1.SafeDecimal(obj.base_amount).toString() : null,
                quote_amount: obj.balance_in_usdt ? new trade_utils_lib_1.SafeDecimal(obj.quote_amount).toString() : null,
                delta_grid_profit_usdt: obj.delta_grid_profit_usdt ? new trade_utils_lib_1.SafeDecimal(obj.delta_grid_profit_usdt).toString() : null,
            };
        });
        const transactions = dataList.reduce((prev, next) => prev + next.transaction, 0);
        let temp_period_type = 1;
        if (list.length > 1) {
            const temp_time_block = list[list.length - 1].time_block - list[0].time_block;
            if (temp_time_block >= 30 * 24 * 60 * 60) {
                temp_period_type = 30;
            }
            else if (temp_time_block <= 24 * 60 * 60) {
                temp_period_type = 1;
            }
            else {
                temp_period_type = 7;
            }
        }
        return {
            period_type: temp_period_type,
            previous_history_trx: transactions,
            sequence: list,
        };
    },
    queryGridOverviewHandle(res) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19;
        return {
            apr: Number((_a = res.apr) !== null && _a !== void 0 ? _a : 0),
            mdd: Number((_b = res.mdd) !== null && _b !== void 0 ? _b : 0),
            seven_day_ror: Number((_c = res.seven_day_ror) !== null && _c !== void 0 ? _c : 0),
            seven_day_ror_usdt: Number((_d = res.seven_day_ror_usdt) !== null && _d !== void 0 ? _d : 0),
            seven_day_mdd: Number((_e = res.seven_day_mdd) !== null && _e !== void 0 ? _e : 0),
            thirty_day_ror: Number((_f = res.thirty_day_ror) !== null && _f !== void 0 ? _f : 0),
            thirty_day_ror_usdt: Number((_g = res.thirty_day_ror_usdt) !== null && _g !== void 0 ? _g : 0),
            thirty_day_mdd: Number((_h = res.thirty_day_mdd) !== null && _h !== void 0 ? _h : 0),
            ninety_day_ror: Number((_j = res.ninety_day_ror) !== null && _j !== void 0 ? _j : 0),
            ninety_day_ror_usdt: Number((_k = res.ninety_day_ror_usdt) !== null && _k !== void 0 ? _k : 0),
            ninety_day_mdd: Number((_l = res.ninety_day_mdd) !== null && _l !== void 0 ? _l : 0),
            half_year_ror: Number((_m = res.half_year_ror) !== null && _m !== void 0 ? _m : 0),
            half_year_ror_usdt: Number((_o = res.half_year_ror_usdt) !== null && _o !== void 0 ? _o : 0),
            half_year_mdd: Number((_p = res.half_year_mdd) !== null && _p !== void 0 ? _p : 0),
            aror: Number((_q = res.aror) !== null && _q !== void 0 ? _q : 0),
            aror_usdt: Number((_r = res.aror_usdt) !== null && _r !== void 0 ? _r : 0),
            aror_mdd: Number((_s = res.aror_mdd) !== null && _s !== void 0 ? _s : 0),
            rota: Number((_t = res.rota) !== null && _t !== void 0 ? _t : 0),
            rota_usdt: Number((_u = res.rota_usdt) !== null && _u !== void 0 ? _u : 0),
            total_income: Number((_v = res.total_income) !== null && _v !== void 0 ? _v : 0),
            average_price: Number((_w = res.average_price) !== null && _w !== void 0 ? _w : 0),
            ath: Number((_x = res.ath) !== null && _x !== void 0 ? _x : 0),
            paired_count: Number((_y = res.paired_count) !== null && _y !== void 0 ? _y : 0),
            paired_apr: Number((_z = res.paired_apr) !== null && _z !== void 0 ? _z : 0),
            open_quote_price: Number((_0 = res.open_quote_price) !== null && _0 !== void 0 ? _0 : 0),
            seven_day_grid_ror_usdt: Number((_1 = res.seven_day_grid_ror_usdt) !== null && _1 !== void 0 ? _1 : 0),
            seven_day_profit_usdt: Number((_2 = res.seven_day_profit_usdt) !== null && _2 !== void 0 ? _2 : 0),
            seven_day_grid_profit_usdt: Number((_3 = res.seven_day_grid_profit_usdt) !== null && _3 !== void 0 ? _3 : 0),
            thirty_day_grid_ror_usdt: Number((_4 = res.thirty_day_grid_ror_usdt) !== null && _4 !== void 0 ? _4 : 0),
            thirty_day_profit_usdt: Number((_5 = res.thirty_day_profit_usdt) !== null && _5 !== void 0 ? _5 : 0),
            thirty_day_grid_profit_usdt: Number((_6 = res.thirty_day_grid_profit_usdt) !== null && _6 !== void 0 ? _6 : 0),
            ninety_day_grid_ror_usdt: Number((_7 = res.ninety_day_grid_ror_usdt) !== null && _7 !== void 0 ? _7 : 0),
            ninety_day_profit_usdt: Number((_8 = res.ninety_day_profit_usdt) !== null && _8 !== void 0 ? _8 : 0),
            ninety_day_grid_profit_usdt: Number((_9 = res.ninety_day_grid_profit_usdt) !== null && _9 !== void 0 ? _9 : 0),
            half_year_grid_ror_usdt: Number((_10 = res.half_year_grid_ror_usdt) !== null && _10 !== void 0 ? _10 : 0),
            half_year_profit_usdt: Number((_11 = res.half_year_profit_usdt) !== null && _11 !== void 0 ? _11 : 0),
            half_year_grid_profit_usdt: Number((_12 = res.half_year_grid_profit_usdt) !== null && _12 !== void 0 ? _12 : 0),
            grid_aror_usdt: Number((_13 = res.grid_aror_usdt) !== null && _13 !== void 0 ? _13 : 0),
            year_profit_usdt: Number((_14 = res.year_profit_usdt) !== null && _14 !== void 0 ? _14 : 0),
            year_grid_profit_usdt: Number((_15 = res.year_grid_profit_usdt) !== null && _15 !== void 0 ? _15 : 0),
            grid_rota_usdt: Number((_16 = res.grid_rota_usdt) !== null && _16 !== void 0 ? _16 : 0),
            profit_usdt: Number((_17 = res.profit_usdt) !== null && _17 !== void 0 ? _17 : 0),
            grid_profit_usdt: Number((_18 = res.grid_profit_usdt) !== null && _18 !== void 0 ? _18 : 0),
            rota_mdd: Number((_19 = res.rota_mdd) !== null && _19 !== void 0 ? _19 : 0),
        };
    },
};
